import Entity from "./entity";

export default class Merchant extends Entity<number> {
  name: string;
  supplierId: number;
  supplier: null;
  appId: string;
  appKey: string;
  mid: string;
  tid: string;
  notifyUrl: null;
  remark: null;
  authorization: null;
  isMain: boolean;
  lastModificationTime: null;
  lastModifierUserId: null;
  creationTime: Date;
  creatorUserId: null;
}
